module.exports = __webpack_public_path__ + "img/level_center.43b66a0b.png";